import { RootState } from '@src/redux/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import { DASHBOARD_TEACHER, GLOBAL_STATE } from '../constants/actionTypes'

const teacherDashboardSelectors = (state: RootState) => prop(GLOBAL_STATE, state)

export const teacherDashboardSelector = createSelector(teacherDashboardSelectors, data => data[DASHBOARD_TEACHER])
